export default __webpack_public_path__ + "static/media/timer.b2efbc13.svg";